import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "context-menu-buttons-container" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "button-icon" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "button-text" }

import { PropType } from 'vue'

interface Button {
  title: string
  emit: string
  iconSrc?: string
  icon?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MapContextMenu',
  props: {
  title: {
    type: String,
    default: ''
  },
  buttons: {
    type: Array as PropType<Button[]>,
    default: () => [],
    validator: (values: Button[]) => values.every((b) => b.title && b.emit)
  }
},
  setup(__props, { emit: __emit }) {



const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.title.length)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.buttons, (b) => {
        return (_openBlock(), _createElementBlock("div", {
          key: b.title,
          class: "context-menu-buttons-container__row",
          onClick: () => emit(b.emit)
        }, [
          _createElementVNode("div", _hoisted_5, [
            (b.iconSrc)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "button-icon__image",
                  src: b.iconSrc
                }, null, 8, _hoisted_6))
              : (b.icon)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(b.icon), { key: 1 }))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(b.title), 1)
        ], 8, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})